import assetPath from '/app/packages/lebenslauf/articles/src/assets/feedback.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')